import axios from 'axios'
import React, { Component } from 'react'
import { View, ActivityIndicator } from 'react-native'
import aPICaller from '../../API/APICaller'
import { Stepper } from '../../Component'
import { TextButton } from '../../Component/Button/TextButton'
import { MainFlowHeaderContainerNoFeedback } from '../../Component/Header/MainFlowHeader'
import { NormalTextInput } from '../../Component/Input/NormalTextInput'
import MyToast from '../../Component/Toast/MyToast'
import MyData from '../../Data/MyData'
import { strings } from '../../Language/Language'
import { check_camera_permission } from '../../Permission/Permission'
import { MainColor } from '../../UI/Color'
import { HeightDimen } from '../../UI/Dimensions'

class QRSignUpScreen extends Component {
  state = {
    username: '',
    isLoading: false,
  }

  async componentDidMount() {
    await this.getCountryFromIP()
  }

  getCountryFromIP = async () => {
    try {
      this.setState({ isLoading: true })
      const resp = await axios.get('https://geolocation-db.com/json/', {
        timeout: 4000,
      })
      if (resp?.status == 200) MyData.setIpLocation(resp?.data)
    } catch (error) {
      this.setState({ isLoading: false })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  onBackPressed = () => {
    this.props.navigation.goBack()
  }

  onNextPressed = async () => {
    if (this.state.username != '') {
      await this.onValidateUser(this.state.username)
    } else {
      MyToast.popToast(strings.t('invalid_data_input'))
    }
  }
  async onPressQRScanner() {
    const res = await check_camera_permission()
    if (res) {
      if (this.props.isFromInfo) this.props.navigation.navigate('QRCodes')
      else this.props.navigation.navigate('QRCode')
    }
  }
  onValidateUser = async (username) => {
    this.setState({ isLoading: true })
    await aPICaller
      .validateUser(username)
      .then((res) => {
        console.log(res)
        MyData.receommender_name = username
        if (this.props.isFromInfo) this.props.navigation.navigate('SignUps')
        else this.props.navigation.navigate('SignUp')
        this.setState({
          isLoading: false,
        })
      })
      .catch((err) => {
        MyToast.popToast(err.response.data.msg)
        this.setState({ isLoading: false })
      })
  }

  render() {
    return (
      <View
        style={{
          flex: 1,
          backgroundColor: 'white',
        }}
      >
        <MainFlowHeaderContainerNoFeedback
          title={strings.t('signUp_text')}
          onBackPress={() => this.onBackPressed()}
        >
          <View
            style={{
              flex: 1,
              paddingHorizontal: HeightDimen(20),
              paddingTop: HeightDimen(20),
            }}
          >
            <Stepper step={1} />
            <NormalTextInput
              placeholder={strings.t('username_text')}
              onChangeText={(val) => {
                this.setState({ username: val })
              }}
              type={'username'}
              iconPress={() => this.onPressQRScanner()}
              iconSrc={require('../../Resources/Images/Footer/icon_qr.png')}
              value={this.state.username}
            />
            {!this.state.isLoading ? (
              <View style={{ marginTop: HeightDimen(20) }}>
                <TextButton
                  label={strings.t('next')}
                  size={5}
                  onPress={() => this.onNextPressed()}
                />
              </View>
            ) : (
              <ActivityIndicator
                size="small"
                color={MainColor}
                style={{ marginTop: HeightDimen(20) }}
              />
            )}
          </View>
        </MainFlowHeaderContainerNoFeedback>
      </View>
    )
  }
}

export default QRSignUpScreen
